/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { SeasonStats } from '@interfaces/participant.interface';
import { Component, Input } from '@angular/core';
import { fromPairs, cloneDeep, omitBy } from 'lodash-es';
import { BaseComponent } from '@components/base.component';
import { OmitStatsKeys, STATSGROUP, STATSGROUPSDATA } from '@interfaces/stats.interface';


@Component({
    selector: 'app-participant-season-stats',
    templateUrl: './season-stats.component.html',
})
export class ParticipanseasonstatsComponent extends BaseComponent {
    @Input()
    public tournamentName: string;

    @Input()
    public tournamentCodename?: string;

    @Input()
    public betradarMajorLeague: boolean;

    @Input()
    public seasonName: string;

    @Input()
    public subtournamentName?: string|null;

    @Input()
    public stats: SeasonStats;

    public constructor() {
        super();
    }

    get statsData(): [keyof Omit<SeasonStats, OmitStatsKeys>, string][] {
        const sort = Object.keys(this.stats)
            .sort().map(key => [key, this.stats[key]]);
        return sort as [keyof Omit<SeasonStats, OmitStatsKeys>, string][];
    }

    get statsVal(): Record<string, any> {
        const groups = cloneDeep(STATSGROUPSDATA);
        const allKeys: string[] = [];
        for (const key in groups) {
            const val = Object.keys(groups[key]);
            allKeys.push(...val);
            groups[key] = { ...groups[key], ...fromPairs((this.statsData.filter(v => val.includes(v[0] as any)))) };
            groups[key] = omitBy(groups[key], value => !value);
            if (Object.keys(groups[key]).length === 0) {
                delete groups[key];
            }
        }

        const notFound = this.statsData.filter(v => !allKeys.includes(v[0] as any));


        this.calculateDynamicParams(groups);
        groups[STATSGROUP.INIT] = { ...groups[STATSGROUP.INIT], ...fromPairs(notFound) };

        return groups;
    }

    public getParticipantStatKey(key: string): string {
        if (this.isAmericanFootball(this.sportName) && key === 'field_goals_made') {
            return `web.${this.sportName}_participant_stats_${key}`;
        }

        let translationCodeName = 'web.participant_stats_';

        if (!this.isAmericanFootball(this.sportName) && this.betradarMajorLeague && this.tournamentCodename) {
            translationCodeName += `${this.tournamentCodename.toLowerCase()}_`;
        }

        translationCodeName += key;

        return translationCodeName;
    }

    /**
     *  Extra dynamic parameters
     */
    private calculateDynamicParams(groups: Record<string, any>): Record<string, any> {
        if (groups[STATSGROUP.GENERAL]) {
        /** Passes Total */
            const isPasses = 'passes_total' in groups[STATSGROUP.GENERAL] &&
        'passes_unsuccessful' in groups[STATSGROUP.GENERAL] && 'passes_successful' in groups[STATSGROUP.GENERAL];
            if (isPasses) {
                if (!groups[STATSGROUP.GENERAL].passes_successful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].passes_successful.value;
                    groups[STATSGROUP.GENERAL].passes_successful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].passes_total.value) * 100).toFixed(2)}%`;
                }
                if (!groups[STATSGROUP.GENERAL].passes_unsuccessful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].passes_unsuccessful.value;
                    groups[STATSGROUP.GENERAL].passes_unsuccessful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].passes_total.value) * 100).toFixed(2)}%`;
                }
            }

            /** Long Passes Total */
            const isLongPasses = 'long_passes_total' in groups[STATSGROUP.GENERAL] &&
        'long_passes_unsuccessful' in groups[STATSGROUP.GENERAL] &&
        'long_passes_successful' in groups[STATSGROUP.GENERAL];
            if (isLongPasses) {
                if (!groups[STATSGROUP.GENERAL].long_passes_successful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].long_passes_successful.value;
                    groups[STATSGROUP.GENERAL].long_passes_successful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].long_passes_total.value) * 100).toFixed(2)}%`;
                }
                if (!groups[STATSGROUP.GENERAL].long_passes_unsuccessful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].long_passes_unsuccessful.value;
                    groups[STATSGROUP.GENERAL].long_passes_unsuccessful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].long_passes_total.value) * 100).toFixed(2)}%`;
                }
            }

            /** Crosses Total */
            const isCrosses = 'crosses_total' in groups[STATSGROUP.GENERAL] &&
'crosses_unsuccessful' in groups[STATSGROUP.GENERAL] &&
        'crosses_successful' in groups[STATSGROUP.GENERAL];
            if (isCrosses) {
                if (!groups[STATSGROUP.GENERAL].crosses_successful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].crosses_successful.value;
                    groups[STATSGROUP.GENERAL].crosses_successful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].crosses_total.value) * 100).toFixed(2)}%`;
                }
                if (!groups[STATSGROUP.GENERAL].crosses_unsuccessful.value.includes('%')) {
                    const val = groups[STATSGROUP.GENERAL].crosses_unsuccessful.value;
                    groups[STATSGROUP.GENERAL].crosses_unsuccessful.value = `${val} / ${((+val /
                        +groups[STATSGROUP.GENERAL].crosses_total.value) * 100).toFixed(2)}%`;
                }
            }
        }
        /** Tackles Total */
        if (groups[STATSGROUP.DEFENSE]) {
            const isTackles = 'tackles_total' in groups[STATSGROUP.DEFENSE] &&
    'tackles_unsuccessful' in groups[STATSGROUP.DEFENSE] &&
            'tackles_successful' in groups[STATSGROUP.DEFENSE];
            if (isTackles) {
                if (!groups[STATSGROUP.DEFENSE].tackles_successful.value.includes('%')) {
                    const val = groups[STATSGROUP.DEFENSE].tackles_successful.value;
                    groups[STATSGROUP.DEFENSE].tackles_successful.value = `${val} / ${((+val /
                            +groups[STATSGROUP.DEFENSE].tackles_total.value) * 100).toFixed(2)}%`;
                }
                if (!groups[STATSGROUP.DEFENSE].tackles_unsuccessful.value.includes('%')) {
                    const val = groups[STATSGROUP.DEFENSE].tackles_unsuccessful.value;
                    groups[STATSGROUP.DEFENSE].tackles_unsuccessful.value = `${val} / ${((+val /
                            +groups[STATSGROUP.DEFENSE].tackles_total.value) * 100).toFixed(2)}%`;
                }
            }
        }

        return groups;
    }
}
